<template>
  <section id="outstanding">
    <h1>what I'm good at</h1>
    <div class="section-description">
      <p class="no-print">
        I'm really good at <b>abstract thinking</b>: understanding business problems and explaining complex issues to both technical and non-technical colleagues. Also being able to have meaningful conversations with people from every team, experience and level.
      </p>
      <p class="no-print">
        This also helps when <b>designing the architecture and experiencies</b> of products and when discussing the pros and cons of each solution with colleagues.
      </p>
      <p class="no-print">
        Because of the motivation to learn <em>new stuff</em>, when picking up tasks I'll always go for the more <b>challenging</b> ones. That means teams that tend to do pair programming or encourage cross-team work are important to me as well.
      </p>
      <ul
        class="print-only"
        style="list-style: inside '—'"
      >
        <li>
          Designing and building web front-end experiencies with any technology
        </li>
        <li>
          Creating easy-to-read, maintainable, tested and scalable architectures and patterns
        </li>
        <li>
          Automating as much as we possibly can
        </li>
        <li>
          Presenting complex technologies in simple terms to any audience
        </li>
        <small>(full redaction at website)</small>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Outstanding'
}
</script>
